import { Dropdown, message, Tag } from 'antd';
import {
  Col,
  Row,
  TabsProps,
  Tabs,
  Space,
  Modal,
  Form,
  DatePicker,
  Input,
} from 'antd';
import { MainLayout } from 'components';
import { useFormik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import {
  AddIcon,
  Calendar,
  CategoryCancel,
  Edit2,
  Edit3Icon,
  EditIcon,
  EditInfo,
  Folder,
  MoreOption,
  ShopingCart,
  UpdateIcon,
} from 'assets/svg';
import { Content } from 'antd/es/layout/layout';
import ProductInfo from 'components/Modules/Product/ProductInfo';
import HistoryPhanBo from 'components/Modules/Product/HistoryPhanBo';
import HistoryUpdate from 'components/Modules/Product/HistoryUpdate';
import ListAttachFile from 'components/Modules/Product/ListAttachFile';
import { category, tag } from 'assets/images';
import Button from 'components/Button';
import type { DatePickerProps } from 'antd';
import { useMutation, useQuery } from 'react-query';
import handleError401 from 'utils/handleError401';
import { IProduct, IProductImage } from 'interface/product.interface';
import { STATUS } from 'constants/reponseStatus';
import pageTitleStore from 'store/pageTitleStore';
import CartProduct from 'components/Modules/Cart/CartlList/CartProduct';
import CartInfo from 'components/Modules/Cart/CartlList/CartInfo';
import CartApi from 'apis/CartApi';
import moment from 'moment';
import { MenuProps } from 'antd/lib';
import {
  DeleteOutlined,
  DownloadOutlined,
  ShoppingCartOutlined,
} from '@ant-design/icons';
import { ICart } from 'interface/cart.interface';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import useQueryParam from 'hooks/useQueryPrams';
import { openNotificationWithIcon } from 'utils/notification';
import PopupConfirmBase from 'components/PopupConfirmBase';

interface Iparam {
  id: string;
}

export default function CartDetailPage() {
  const { id } = useParams<Iparam>();
  const history = useHistory();
  const [cart, setCart] = useState<ICart>();
  const { TextArea } = Input;
  const step = useCategoryManagementStore((state) => state.step);
  const [product, setProduct] = useState<IProduct>();
  const [modalSyncVisible, setModalSyncVisible] = useState(false);
  const [status, setStatus] = useState<number>(1);
  const [images, setImages] = useState<IProductImage[]>([]);
  const [mainPic, setMainPic] = useState<IProductImage>();
  const [mainIndex, setMainIndex] = useState<number>();
  const [dataUpdate, setDataUpdate] = useState<any>();
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: `Sản phẩm`,
      children: <CartProduct id={id} />,
    },
    {
      key: '2',
      label: `Thông tin`,
      children: <CartInfo cart={cart} />,
    },
    // {
    //   key: '3',
    //   label: `Danh sách đăng ký`,
    //   children: `Content of Tab Pane 1`,
    // },
    // {
    //   key: '4',
    //   label: `Đơn hàng`,
    //   children: `Content of Tab Pane 2`,
    // },
    // {
    //   key: '5',
    //   label: `Lịch sử phê duyệt`,
    //   children: `Content of Tab Pane 3`,
    // },
  ];

  const { isLoading: isCartLoading } = useQuery(
    ['getDetail'],
    () => CartApi.getDetail(id),
    {
      onSuccess: (response) => {
        if (response.status === STATUS.SUCCESS) {
          setCart(response.data);
        }
      },
      onError: (error: any) => {
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  const handleChangeInput = (name: string) => {
    return (e: any) => {
      formik.setFieldValue(name, e.target.value);
    };
  };

  const handleDateChange = (name: string): DatePickerProps['onChange'] => {
    return (date, dateString) => {
      formik.setFieldValue(name, dateString);
    };
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: cart?.id,
      release_date: '',
      expiration_date: '',
      description: '',
    },
    onSubmit(values) {
      const newValues =
        cart?.status === 2
          ? {
              expiration_date: moment(
                values?.expiration_date,
                'YYYY-MM-DD HH:mm:ss'
              ).toISOString(),
            }
          : {
              id: `${values.id}`,
              release_date: moment(
                values?.release_date,
                'YYYY-MM-DD HH:mm:ss'
              ).toISOString(),
              expiration_date: moment(
                values?.expiration_date,
                'YYYY-MM-DD HH:mm:ss'
              ).toISOString(),
              description: values?.description,
            };
      CartApi.editInfo(newValues)
        .then((res) => {
          console.log(res);
          if (res.success) {
            message.success('Cập nhật thành công');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  });

  useEffect(() => {
    if (cart) {
      setTitle(cart?.cart_name || '');
      setBreadcrumb([
        { title: <a href="">Giỏ hàng</a> },
        { title: <a href="/cart-list">Phát hành giỏ hàng</a> },
        { title: <a href="">{cart?.cart_name || ''}</a> },
      ]);
    }
  }, [cart]);

  const menuItems: MenuProps = {
    items: [
      {
        label: 'Chỉnh sửa thông tin',
        key: '1',
        icon: <EditInfo />,
        onClick: () => {
          // setModalSyncVisible(true);
          if (
            cart?.status == 0 &&
            Date.now() < new Date(cart?.expiration_date).getTime()
          ) {
            history.push(`/declare-cart-info`, { currentData: cart });
          } else {
            openNotificationWithIcon(
              'error',
              'Không thể chỉnh sửa giỏ hàng này'
            );
          }
        },
      },
      // {
      //   label: 'Tải file excel',
      //   key: '2',
      //   icon: <DownloadOutlined />,
      // },
      {
        label: <div className="text-red-600">Xóa giỏ hàng</div>,
        key: '3',
        icon: <CategoryCancel />,
        onClick: () => {
          setIsModalOpen(true);
        },
      },
    ],
  };

  const { mutate: deleteCart, isLoading: isDeleteLoading } = useMutation(
    () => CartApi.delete(id),
    {
      onSuccess: (data) => {
        history.push('/cart-list');
      },
      onError: (error: any) => {
        console.log(error);
      },
    }
  );

  const addCategory = () => {
    history.push(`/declare-cart-product/${id}/${cart?.cart_type}`, {
      edit: true,
    });
  };

  const openModal = (content: string) => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const convertCartStatus = (status: any) => {
    switch (status) {
      case 0:
        return 'Mới tạo';
      case 1:
        return 'Đã phát hành';
      case 2:
        return 'Hết hạn';
      case 3:
        return 'Vô hiệu hoá';
      default:
        return '-';
    }
  };

  return (
    <MainLayout isLoading={isCartLoading || isDeleteLoading}>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-4"
      >
        {/* <Col span={12} className="flex justify-end">
          <Space>
            <Button onClick={addCategory}>
              <AddIcon />
              Thêm danh mục
            </Button>
          </Space>
        </Col> */}
      </Row>
      <Modal
        visible={modalSyncVisible}
        onCancel={() => {
          setModalSyncVisible(false);
        }}
        footer={null}
        width={'70%'}
      >
        <Content className="w-full">
          <p className="text-2xl font-bold pb-6 border-b-2 border-neutral-90">
            Chỉnh sửa giỏ hàng
          </p>
          <div className="cart-info py-6 border-b-2 border-dashed border-neutral-90">
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="start">
              <Col className="text-sm" span={4}>
                Tên giỏ hàng
              </Col>
              <Col span={20}>
                : <span className="text-sm font-bold">{cart?.cart_name}</span>
              </Col>
            </Row>
            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              justify="start"
              className="mt-5"
            >
              <Col span={4}>Mã giỏ hàng</Col>
              <Col span={8}>
                : <span className="text-sm">{cart?.cart_code}</span>
              </Col>
              <Col span={4}>Loại giỏ hàng</Col>
              <Col span={8}>
                : <span className="text-sm">{cart?.cart_type_name}</span>
              </Col>
            </Row>
            {cart?.status === 2 && (
              <Row
                gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                justify="start"
                className="mt-5"
              >
                <Col span={4}>Mô tả</Col>
                <Col span={8}>
                  : <span className="text-sm">{cart?.description}</span>
                </Col>
              </Row>
            )}
          </div>
          <Form
            className="mt-5"
            layout="vertical"
            onSubmitCapture={formik.handleSubmit}
          >
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="start">
              {cart?.status !== 2 && (
                <Col span={12}>
                  <Form.Item label="Ngày bắt đầu phát hành">
                    <DatePicker
                      onChange={handleDateChange('release_date')}
                      placeholder="Ngày bắt đầu phát hành"
                      format={'DD/MM/YYYY'}
                    />
                  </Form.Item>
                </Col>
              )}
              <Col span={12}>
                <Form.Item label="Ngày hết hạn">
                  <DatePicker
                    onChange={handleDateChange('expiration_date')}
                    placeholder="Ngày hết hạn"
                    format={'DD/MM/YYYY'}
                  />
                </Form.Item>
              </Col>
            </Row>

            {cart?.status !== 2 && (
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="start">
                <Col span={24}>
                  <Form.Item label="Mô tả giỏ hàng">
                    {' '}
                    <TextArea
                      onChange={handleChangeInput('description')}
                      required={false}
                      maxLength={500}
                      rows={4}
                      showCount
                      placeholder="Nhập mô tả"
                      style={{ marginRight: '10px' }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}

            <div className="flex items-center justify-end mt-8 gap-6">
              <Button
                onClick={() => {
                  setModalSyncVisible(false);
                }}
                customClass="text-neutral-50"
                bgColor="white"
              >
                Huỷ
              </Button>
              <Button type="submit">Cập nhật</Button>
            </div>
          </Form>
        </Content>
      </Modal>

      <Content className="mb-4">
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          className="flex justify-between mb-6"
        >
          <Row justify={'start'}>
            <Col className="flex items-center">
              <Tag color="#00538F" className="custom-tag ml-2 border-2">
                <span className="text-base font-bold mt-4">
                  {/* {cart?.status == 0 ? 'Mới tạo' : 'Đã phát hành'} */}
                  {convertCartStatus(cart?.status)}
                </span>
              </Tag>
            </Col>
            <Col className="">
              <p>
                <strong style={{ fontSize: '28px' }}>{cart?.cart_name}</strong>
              </p>
            </Col>
          </Row>
          <Col span={2} className="flex justify-end ">
            <Dropdown menu={menuItems} trigger={['click']} placement="topRight">
              <Space>
                <MoreOption />
              </Space>
            </Dropdown>
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col flex="auto">
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-4">
              <Col className="" span={5}>
                <div className="text-base font-bold text-neutral-80 flex items-center gap-2">
                  <ShopingCart />
                  <div>Mã giỏ hàng</div>
                </div>
                <div className="text-base font-semibold text-neutral-30 ml-8">
                  {cart?.cart_code}
                </div>
              </Col>

              <Col className="" span={5}>
                <div className="text-base font-bold text-neutral-80 flex items-center gap-2">
                  <Folder />
                  <div>Loại giỏ hàng</div>
                </div>
                <div className="text-base font-semibold text-neutral-30 ml-8 ">
                  {cart?.cart_type_name}
                </div>
              </Col>
              <Col className="" span={5}>
                <div className="text-base font-bold text-neutral-80 flex items-center gap-2">
                  <Calendar />
                  <div>Ngày phát hành</div>
                </div>
                <div className="text-base font-semibold text-neutral-30 ml-8">
                  {moment(cart?.release_date).format('DD/MM/YYYY')}
                </div>
              </Col>
              <Col className="" span={5}>
                <div className="text-base font-bold text-neutral-80 flex items-center gap-2">
                  <Calendar />
                  <div>Ngày hết hạn</div>
                </div>
                <div className="text-base font-semibold text-neutral-7030 ml-8">
                  {moment(cart?.expiration_date).format('DD/MM/YYYY')}
                </div>
              </Col>
              <Col className="" span={4}>
                <div className="text-base font-bold text-neutral-80 flex items-center gap-2">
                  <Calendar />
                  <div>Ngày hiệu lực</div>
                </div>
                <div className="text-base font-semibold text-neutral-7030 ml-8">
                  {cart?.effective_date
                    ? moment(cart?.effective_date).format('DD/MM/YYYY')
                    : '-'}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Content>
      <Content>
        <Tabs defaultActiveKey="1" items={items} />
      </Content>
      <PopupConfirmBase
        isVisible={isModalOpen}
        title={'Thông báo'}
        description={'Bạn có muốn xóa giỏ hàng hay không?'}
        onOk={() => {
          deleteCart();
        }}
        onCancel={closeModal}
      ></PopupConfirmBase>
    </MainLayout>
  );
}
